import path from 'path';
import { EditEventPageParameters, LoginPageQueryParameters } from '~admin/view/pages/parameters';
import { compilePath, compileWithParams } from '~common/route/path-to-regexp';

export const BasePaths = {
  tool: '/',
};

export const Paths = {
  login: '/login',
  logout: '/logout',
  test: '/test',
  tool: {
    base: path.join(BasePaths.tool, ''),
    clients: path.join(BasePaths.tool, 'clients'),
    createEvent: path.join(BasePaths.tool, 'createEvent'),
    editEvent: path.join(BasePaths.tool, 'editEvent/:eventId'),
    events: path.join(BasePaths.tool, 'events'),
  },
  consumer: {
    eventLanding: 'events/:vanityName?/:eventId',
  },
};

//TODO: Merge with links from consumer and use hooks instead of constants

interface EventPageParameters {
  eventId: string;
  vanityName?: string;
}

export const Links = {
  login: compileWithParams<any, LoginPageQueryParameters>(Paths.login),
  tool: {
    editEvent: compileWithParams<EditEventPageParameters>(Paths.tool.editEvent),
  },
  consumer: {
    eventLanding: compilePath<EventPageParameters>(Paths.consumer.eventLanding),
  },
};



// WEBPACK FOOTER //
// ./route/index.ts